// PeptideVault v6.5 — Titlebar, sidebar, notifications

// ══════════════════════════════════════════════════════
// RENDER: TITLEBAR
// ══════════════════════════════════════════════════════
function renderTitlebar() {
  const lowCount = getAlertCount()
  return `
  <div class="titlebar">
    <div class="tbar-breadcrumb">${hubForTab(S.tab)}</div>
    <span class="tbar-release">PeptideVault&nbsp; ${APP_VERSION}</span>
    <button class="tbar-search" onclick="openSearch()" title="Search PeptideVault">
      <span class="tbar-search-icon"><svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="7" cy="7" r="4.5"/><line x1="10.5" y1="10.5" x2="14" y2="14"/></svg></span>
      <span class="tbar-search-placeholder">Search protocols, peptides, labs…</span>
      <kbd>⌘K</kbd>
    </button>
    <div class="tbar-spacer"></div>
    <div id="sync-indicator" style="margin-right:6px"></div>
    <div class="tbar-actions">
      <button class="notif-btn btn-icon" onclick="toggleNotif()" title="Alerts">
        ${ICONS.bell}
        ${lowCount ? `<span class="notif-badge">${lowCount}</span>` : ''}
      </button>
      <button class="pv-avatar" onclick="setTab('settings')" title="Settings">${esc(((S.users||[]).find(function(u){return u.active})||{initials:'TO'}).initials||'TO')}</button>
    </div>
  </div>
  ${S.notifOpen ? renderNotifDropdown() : ''}
  `
}

const HUB_TABS = {
  Home:['dashboard','calendar','emergency'],
  Inventory:['inventoryhub','peptides','injsupplies','pens','locations','categories','library','purchaseplan','scanner','vaultmap'],
  Protocols:['protocolshub','allocation','planner','timeline','masterplan','scenarios','cycles','blends','dependencies','forecast'],
  Supplements:['supplements','pillpacks'],
  Health:['healthhub','health','labresults','labcompare','labnorm','healthdocs','notes','analytics','halflife','simulator','regimens','injectionhub'],
  Records:['vaulthub','coas','docs','vendors','exports','recovery','datahealth','duplicates','changelog','audittrail','snapshots','savedviews','trash','syncstatus','diagnostics','templates','helpcenter'],
  Settings:['settings'],
}

function hubForTab(tab) {
  return Object.keys(HUB_TABS).find(function(hub){ return HUB_TABS[hub].includes(tab) }) || 'Home'
}

// ══════════════════════════════════════════════════════
// RENDER: SIDEBAR
// ══════════════════════════════════════════════════════
function renderSidebar() {
  const activeHub = hubForTab(S.tab)
  const macClass = isElectron && !navigator.platform?.includes('Win') ? ' sidebar-mac' : ''
  const sync = typeof getSyncRuntimeStatus === 'function' ? getSyncRuntimeStatus() : { state:'synced' }
  const alertCount = getAlertCount()
  const activeUser = (S.users||[]).find(function(user){return user.active}) || (S.users||[])[0] || { name:'Todd', initials:'TO' }
  const sensor = S._environmentSensorStatus || {}
  const reading = sensor.state === 'connected' && sensor.reading ? sensor.reading : null
  const freezerLabel = reading ? `${Number(reading.temperature).toFixed(1)} °${reading.unit||'C'}` : 'Setup needed'
  const syncBad = sync.state === 'error' || sync.state === 'offline'
  const syncLabel = syncBad ? (sync.error && sync.error.message || 'Sync needs attention') : sync.state === 'syncing' ? 'Syncing…' : sync.state === 'pending' ? 'Changes pending' : 'Synced'
  const navItem = (id, label, icon) => `
    <button class="nav-item ${activeHub===label?'active':''}" onclick="setTab('${id}')">
      <span class="nav-icon">${icon}</span>
      ${esc(label)}
    </button>`
  return `
  <div class="sidebar${macClass}">
    <div class="pv-side-brand"><img src="app-icon.png" alt=""><strong>Peptide<span>Vault</span></strong></div>
    <button class="pv-side-search" onclick="openSearch()">${ICONS.search||'⌕'}<span>Search</span><kbd>⌘K</kbd></button>
    <div class="pv-primary-nav">
      ${navItem('dashboard','Home',ICONS.dashboard)}
      ${navItem('inventoryhub','Inventory',ICONS.peptide)}
      ${navItem('protocolshub','Protocols',ICONS.calendar)}
      ${navItem('supplements','Supplements',ICONS.supplements)}
      ${navItem('healthhub','Health',ICONS.health)}
      ${navItem('vaulthub','Records',ICONS.analytics)}
    </div>
    <div class="sidebar-footer">
      <button class="pv-side-user" onclick="setTab('settings')"><span>${esc(activeUser.initials||String(activeUser.name||'Todd').slice(0,2).toUpperCase())}</span><b>${esc(activeUser.name||'Todd')}</b><i>›</i></button>
      <button class="pv-side-utility" onclick="setTab('settings')"><i>❄</i><span><b>Freezer</b><small>${esc(freezerLabel)}</small></span><em>›</em></button>
      <button class="pv-side-utility ${syncBad?'has-error':''}" onclick="setTab('syncstatus')"><i>${syncBad?'!':sync.state==='syncing'?'↻':'✓'}</i><span><b>${syncBad?'Errors & Sync':'Sync status'}</b><small id="sidebar-sync-status">${esc(sync.progress?.message || syncLabel)}</small></span></button>
      <button class="pv-side-utility notif-btn" onclick="toggleNotif()"><i>♧</i><span><b>Notifications</b><small>${alertCount ? alertCount+' item'+(alertCount===1?'':'s')+' need attention' : 'No new alerts'}</small></span>${alertCount?`<em>${alertCount}</em>`:''}</button>
      <button class="nav-item ${activeHub==='Settings'?'active':''}" onclick="setTab('settings')"><span class="nav-icon">${ICONS.settings}</span>Settings</button>
      <button class="pv-theme-switch" onclick="cycleTheme()" aria-label="Switch between Frosted Blue and Midnight Violet"><span>${isDarkMode()?'☾':'☀'}</span><b>${isDarkMode()?'Midnight Violet':'Frosted Blue'}</b><i>Switch</i></button>
      <div class="pv-side-version">Version ${APP_VERSION}</div>
    </div>
  </div>${S.notifOpen ? renderNotifDropdown() : ''}`
}


// ══════════════════════════════════════════════════════
// RENDER: NOTIFICATION DROPDOWN
// ══════════════════════════════════════════════════════
function renderNotifDropdown() {
  var alerts = getAlerts()
  var severityDot = { critical: 'var(--red)', warning: 'var(--yellow)', info: 'var(--blue)' }
  return `
  <div class="notif-dropdown pv-side-notif-dropdown">
    <div style="padding:12px 16px;border-bottom:1px solid var(--border);font-size:13px;font-weight:700">Alerts (${alerts.length})</div>
    ${alerts.length === 0 ? `<div style="padding:20px;text-align:center;color:var(--text4);font-size:13px">No alerts — everything looks good</div>` :
      alerts.slice(0, 20).map(a => `
        <div class="notif-item" onclick="setTab('${a.tab}');toggleNotif()">
          <div class="notif-dot" style="background:${severityDot[a.severity] || 'var(--text4)'}"></div>
          <div>
            <div style="font-size:13px;font-weight:600">${esc(a.name)}</div>
            <div style="font-size:12px;color:var(--text3)">${esc(a.message)}</div>
            <div style="font-size:10px;color:var(--text4);text-transform:uppercase;letter-spacing:.5px;margin-top:2px">${a.category}</div>
          </div>
        </div>`).join('')}
    ${alerts.length > 20 ? `<div style="padding:8px 16px;font-size:11px;color:var(--text4)">+${alerts.length - 20} more</div>` : ''}
  </div>`
}

export {
  renderTitlebar,
  renderSidebar,
  renderNotifDropdown,
  hubForTab
}
